import { render, staticRenderFns } from "./lookList.vue?vue&type=template&id=38a8411a&scoped=true"
import script from "./lookList.vue?vue&type=script&lang=js"
export * from "./lookList.vue?vue&type=script&lang=js"
import style0 from "./lookList.vue?vue&type=style&index=0&id=38a8411a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8411a",
  null
  
)

export default component.exports